<template>
    <div class="reportClass">
        <el-form :inline="true" class="leader-style-form">
            <!-- <el-row :gutter="10"> -->
            <!-- <el-col :span="5">
                    <el-form-item label="设备号">
                        <el-select v-model="service_area_id">
                            <el-option
                                v-for="item in serviceAreaSearchJson"
                                :key="item.service_area_id"
                                :label="item.service_area_name"
                                :value="item.service_area_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
            </el-col>-->
            <!-- <el-col :span="7"> -->
            <el-form-item label="报修时间">
                <!-- <el-date-picker
                            v-model="searchForm.report_repair_date"
                            type="datetime"
                            placeholder="选择日期"
                            :default-value="timeNow"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            @change="yymmdd"
                ></el-date-picker>-->
                <el-date-picker
                    v-model="searchForm.report_repair_date_range"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
            <!-- </el-col>
            <el-col :span="6">-->
            <el-form-item label="报修单号">
                <el-input v-model="searchForm.report_repair_no" placeholder="请输入报修单号"></el-input>
            </el-form-item>
            <el-form-item style="text-align: right">
                <el-button type="warning" @click="doSearch">查询</el-button>
                <el-button type="primary" @click="addNewOne('addForm', '0')">新增</el-button>
            </el-form-item>
            <!-- </el-col>
            <el-col :span="11" style="text-align: right">-->

            <!-- </el-col>
            </el-row>-->
        </el-form>

        <!-- <div class="title">抢修管理详情</div> -->
        <div class="table-wrap">
            <el-table ref="singleTable" :data="tableJson" border class="leader-style-table">
                <!--@current-change="handleCurrentChange"-->
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <el-table-column label="报修单号" property="report_repair_no" width="180" align="left"></el-table-column>
                <!--                    <el-table-column label="设备号" property="tree_id_list" align="left"></el-table-column>-->
                <el-table-column label="报修人" property="reporter" align="center"></el-table-column>
                <el-table-column label="联系电话" property="reporter_phone" align="center"></el-table-column>
                <el-table-column
                    label="报修时间"
                    property="report_repair_date"
                    width="180"
                    align="center"
                ></el-table-column>
                <el-table-column label="报修来源" property="report_repair_source_name" align="center"></el-table-column>
                <el-table-column label="处理方式" property="report_repair_state_name" align="center"></el-table-column>
                <el-table-column label="关联单号" property="rush_repair_no" width="180" align="center"></el-table-column>
                <el-table-column label="修改" width="250" align="center">
                    <template slot-scope="scope">
                        <span v-if="'0' == user_level">
                            <el-button
                                @click="changeItemShow(scope.row)"
                                type="text"
                                class="button-check"
                            >
                                <i class="iconfont iconeditor"></i>
                                <span class="inner-text">修改</span>
                            </el-button>
                        </span>
                        <span v-else>
                            <el-button
                                @click="addNewOne(scope.row, '1')"
                                type="text"
                                class="button-modify"
                            >
                                <i class="iconfont iconeditor"></i>
                                <span class="inner-text">核实情况</span>
                            </el-button>
                        </span>
                        <el-button @click="transferQX(scope.row)" type="text" class="button-modify">
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">抢修</span>
                        </el-button>
                        <el-button
                            @click="updateRushRepairId(scope.row)"
                            type="text"
                            class="button-modify"
                        >
                            <i class="iconfont iconic_assign"></i>
                            <span class="inner-text">关联抢修单</span>
                        </el-button>
                        <el-button
                            @click="updateState(scope.row)"
                            type="text"
                            class="button-delete"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">报废</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                class="leader-style-pagination"
            ></el-pagination>
        </div>

        <reportrepairAdd
            :addshow.sync="addshow"
            :tree_Names="tree_Names"
            :tree_ids="tree_ids"
            :chooseRow="chooseRow"
            :isnew="isnew"
        ></reportrepairAdd>
        <!--查看dialog-->
        <el-dialog
            title="关联抢修单"
            :visible.sync="detailsShow"
            :close-on-click-modal="false"
            class="leader-dialog"
            width="75%"
        >
            <el-scrollbar style="height: 470px">
                <el-table
                    :data="qiangtableJson"
                    border
                    class="leader-style-table"
                    ref="multipleTable"
                    @row-click="handleRowClick"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        type="index"
                        width="50"
                        align="center"
                        label="序号"
                        property="num"
                    ></el-table-column>
                    <el-table-column label="抢修单号" property="rush_repair_no" align="left"></el-table-column>
                    <el-table-column label="抢修负责人" property="leader_name" align="left"></el-table-column>
                    <el-table-column label="抢修人员" property="worker_names" align="center"></el-table-column>
                    <el-table-column label="抢修内容" property="content" align="center"></el-table-column>
                    <el-table-column label="派单时间" property="op_date" align="center"></el-table-column>
                    <el-table-column label="抢修状态" property="rush_repair_state_name" align="center"></el-table-column>
                    <el-table-column label="回填情况" property="backfill_state_name" align="center"></el-table-column>
                </el-table>
            </el-scrollbar>
            <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum1"
                class="leader-style-pagination"
            ></el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailsShow = false" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    class="leader-common-button"
                    @click="guanlian('addForm')"
                    :loading="this.$store.state.btnType"
                >关联</el-button>
            </div>
        </el-dialog>
        <!-- 抢修 -->
        <Repair_add
            :addshow.sync="qxaddshow"
            :tree_Names="tree_Names"
            :tree_ids="tree_ids"
            :chooseRow="chooseRow"
            :isnew="1"
            :report_repair_id="report_repair_id"
        ></Repair_add>
    </div>
</template>
<script>
import Repair_add from '../repair_rush/repair_add';
import * as api from '../api/index';
import Tree from '@/comon/components/tree.vue';
import Collapes from '@/comon/components/collapse-block.vue';
import reportrepairAdd from './report_repair_add.vue';
import Bus from '@/utils/eventBus.js';

export default {
    components: {
        'me-tree': Tree,
        'me-collapes': Collapes,
        reportrepairAdd,
        Repair_add,
    },
    data() {
        return {
            width: 'calc(100% - 340px)',
            // 分页器数据
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            pageNum1: 1, //页码
            pageSize1: 10, //每页条数
            currentPage1: 1, //当前页码
            totalNum1: 0, //总条数
            treeList: [],
            tableJson: [],
            treeLoading: false,
            tree_id: '1',
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            tree_ids: '',
            tree_Names: '',
            addshow: false,
            qxaddshow: false,
            isnew: true,
            searchForm: {
                report_repair_no: '',
                // report_repair_date: "",
                report_repair_date_range: [],
            },
            user_level: '0',
            detailsShow: false,
            qiangtableJson: [],
            //存储表格选中的行数据
            multipleSelection: [],
        };
    },
    created() {
        this.getPointTree();
        this.selectTaskList();
        Bus.$on('refresh', (message) => {
            //一些操作，message就是从top组件传过来的值
            this.selectTaskList();
        });
    },
    methods: {
        doSearch() {
            this.selectTaskList();
        },
        // 获取table列表
        selectTaskList() {
            api.selectTaskList({
                report_repair_no: this.searchForm.report_repair_no,
                start_show_day:
                    this.searchForm.report_repair_date_range &&
                    this.searchForm.report_repair_date_range[0],
                end_show_day:
                    this.searchForm.report_repair_date_range &&
                    this.searchForm.report_repair_date_range[1],
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }).then((res) => {
                if (res.error_code === '0') {
                    this.tableJson = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.selectTaskList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.selectTaskList();
        },
        handleTreeNodeClick(select) {
            (this.tree_ids = ''),
                this.$refs.myTree.$refs.tree
                    .getCheckedKeys()
                    .forEach((item) => {
                        this.tree_ids += item + ',';
                    });
            if (this.tree_Names.match(select.tree_name)) {
                //判断若已经包含当前选择id，则表示当前操作为取消选择，故把当前节点去掉
                this.tree_Names = this.tree_Names.replace(
                    select.tree_name + ',',
                    ''
                );
            } else {
                this.tree_Names += select.tree_name + ',';
            }
        },
        collapesCb(collapes) {
            this.width = collapes ? 'calc(100% - 340px)' : 'calc(100% - 61px)';
        },
        getPointTree() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeList = res.bus_json;
                    if (this.currentTreeNode && this.currentTreeNode.tree_id) {
                        this.$nextTick(() => {
                            // this.$refs.myTree.$refs.tree.setCurrentNode(this.currentTreeNode);
                        });
                    } else {
                        this.$nextTick(() => {
                            // this.$refs.myTree.$refs.tree.setCurrentNode(this.treeList[0]);
                            // this.handleTreeNodeClick(this.treeList[0]);
                        });
                    }
                }
                this.treeLoading = false;
            });
        },
        // 新增按钮点击
        addNewOne(formName, flag) {
            if ('0' == flag) {
                //新增
                // if (this.tree_Names.length == 0) {
                //     this.addshow = false;
                //     this.$message("请先选择设备！");
                // } else {
                this.isnew = '0';
                this.chooseRow = {};
                this.addshow = true;

                // }
            } else {
                //核实情况
                this.isnew = '2';
                this.chooseRow = formName;
                this.addshow = true;
            }
        },
        transferQX(row) {
            api.selectReportRepairInfo({
                report_repair_id: row.report_repair_id,
            }).then((res) => {
                if (res.error_code == '0') {
                    this.tree_ids = res.bus_json.tree_id_list;
                    this.tree_Names = res.bus_json.tree_id_list_tree_name;
                    this.qxaddshow = true;
                    this.chooseRow = row;
                    this.report_repair_id = row.report_repair_id;
                } else {
                }
            });
        },
        // 获取table列表
        getUserInfo() {
            api.getUserInfo({}).then((res) => {
                if (res.error_code === '0') {
                    this.user_level = res.bus_json.user_level;
                }
            });
        },
        changeItemShow(row) {
            this.isnew = '1'; //修改
            this.chooseRow = row;
            this.addshow = true; //显示新增/修改页面
        },
        updateState(row) {
            this.$confirm('确认作废该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    api.updateState({
                        report_repair_id: row.report_repair_id,
                    }).then((res) => {
                        if (res.error_code === '0') {
                            this.$message({
                                message: '作废成功！',
                                type: 'success',
                            });
                            this.selectTaskList();
                        }
                    });
                })
                .catch((e) => {
                    this.$message({
                        type: 'info',
                        message: '未提交',
                    });
                });
        },
        updateRushRepairId(row) {
            this.chooseRow = row;
            this.detailsShow = true;
            this.getTable();
        },
        // 获取table列表  抢修单列表
        getTable() {
            api.getRushRepairs({
                pageNum: this.pageNum1,
                pageSize: this.pageSize1,
            }).then((res) => {
                if (res.error_code === '0') {
                    this.qiangtableJson = res.bus_json.items;
                    this.totalNum1 = res.bus_json.totalNum;
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange1(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getTable();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange1(e) {
            this.pageNum = e;
            this.getTable();
        },
        /**
         * 选择关联抢修单单号，进行关联操作
         */
        // 多选框选中数据
        handleSelectionChange(selection) {
            if (selection.length > 1) {
                this.$refs.multipleTable.clearSelection();
                this.$refs.multipleTable.toggleRowSelection(selection.pop());
            } else {
                this.multipleSelection = selection.pop();
            }
            //this.ids = selection.map(item => item.driverId)
            //this.single = selection.length!=1
            //this.multiple = !selection.length
        },
        handleRowClick(row, column, event) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        //关联抢修单请求
        guanlian() {
            this.$emit('changeRelatedDriver', this.multipleSelection);
            api.updateRushRepairId({
                report_repair_id: this.chooseRow.report_repair_id,
                rush_repair_id: this.multipleSelection.rush_repair_id,
            }).then((res) => {
                if (res.error_code === '0') {
                    this.$message({
                        message: '关联成功！',
                        type: 'success',
                    });
                    this.detailsShow = false;
                    this.selectTaskList();
                }
            });
        },
    },
};
</script>
<style lang="scss">
.reportClass {
    // width: 100%;
    // height: 85%;
    // display: flex;
    // flex-direction: row;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        // height: 700px;
        height: 100%;
    }
    .el-date-editor .el-range-input {
        background-color: transparent;
    }
    .el-date-editor .el-range-input {
        color: #fff !important;
    }
    .tree-wrap {
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;
        width: 280px;
        overflow: hidden;
        box-sizing: border-box;
    }

    .right_container {
        box-sizing: border-box;
        // margin: 4px 30px 10px 0;
    }
}
</style>
